package com.shadowings.gero.data.lessons.chapter4

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_1
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_2
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_3
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_4
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_5
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_6
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_7
import gero.composeapp.generated.resources.exp_content_transliteration_reading_dialog_8
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_1
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_2
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_3
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_4
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_5
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_6
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_7
import gero.composeapp.generated.resources.exp_content_transliteration_reading_point_8
import gero.composeapp.generated.resources.lesson_transliteration_reading_title

fun getTransliterationReadingContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_1,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_2,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_3,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_4,
            face = Faces.Perfect
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_5,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_6,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_7,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_point_8,
            face = Faces.Perfect,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_1,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_2,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_3,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_4,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_5,
            face = Faces.Perfect,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_6,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_7,
            face = Faces.Perfect,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.lesson_transliteration_reading_title,
            content = Res.string.exp_content_transliteration_reading_dialog_8,
            face = Faces.Surprised,
            character = Characters.Alyn,
        )
    )
}
